import { environment } from '@env/environment';

// Имя куки с access-токеном зависит от окружения, чтобы test/prod/dev
// не затирали друг друга на общем родительском домене (.speaknode.com).
export const ACCESS_TOKEN_COOKIE = environment.name === 'prod'
  ? 'access_token'
  : `${environment.name}_access_token`;
